export interface IWebsiteSidebarItem {
  name: string;
  label: string;
  type: 'simple' | 'static' | 'dropdown' | 'accordion';
  disabled?: boolean;
  hidden?: boolean;
  img?: string;
  beta?: boolean;
  icon?: string;
}

export abstract class WebsiteSidebarItem implements IWebsiteSidebarItem {
  name: string;
  label: string;
  type: 'simple' | 'static' | 'dropdown' | 'accordion';
  disabled?: boolean;
  hidden?: boolean;
  notification?: boolean;
  beta?: boolean;
  img?: string;
  icon?: string;

  protected constructor(
    name: string,
    label: string,
    type: 'simple' | 'static' | 'dropdown' | 'accordion',
    img?: string,
    icon?: string,
    disabled?: boolean,
    hidden?: boolean,
    notification?: boolean,
    beta?: boolean
  ) {
    this.name = name;
    this.label = label;
    this.type = type;
    this.disabled = disabled;
    this.hidden = hidden;
    this.notification = notification;
    this.beta = beta;
    img && (this.img = img);
    icon && (this.icon = icon);
  }
}
